import { HEADER_STYLE } from "../../siteInfo/SiteStyle";
const mainSlickSliderStyle = {
  sliderImg: {
    width: "100%",
    height: 750,
    position: "relative",
    overflow: "hidden",
    objectFit: "cover",
    animation: "moveImage infinite 18s linear alternate",
  },
  sliderMessage: {
    fontFamily: HEADER_STYLE.headerMessageFontFamily,
    width: "80%",
    textAlign: "center",
    fontSize: HEADER_STYLE.headerMessageFontSize,
    textShadow: "3px 3px 9px #333333",
    color: "#ffffff",
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%,-50%)",
  },
};

export default mainSlickSliderStyle;
